const DisabledValues = Object.freeze({
    '--disabled': '0.32',
});
const States = {
    disabled: 'var(--disabled)',
};
/* export enum StatesZ {
    enabled = 'enabled',
    disabled = 'disabled',
    readonly = 'readonly',

    focused = 'focused',
    hovered = 'hovered',
    pressed = 'pressed',
    selected = 'selected',
    loading = 'loading',
    error = 'error',
    hidden = 'hidden',
    active = 'active',
    inactive = 'inactive',
    valid = 'valid',
    invalid = 'invalid',
    warning = 'warning',
    expanded = 'expanded',
    collapsed = 'collapsed',
} */

export { DisabledValues, States };
